import { render, staticRenderFns } from "./newLanding.vue?vue&type=template&id=9f791d1a"
import script from "./newLanding.vue?vue&type=script&lang=js"
export * from "./newLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports